import { IGetChecklistMaquinaEquipDropDownUseCase } from "../../../presentation/useCases/read/get_checklist_maquina_equip_drop_down_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
import { DropDown } from "../../../../../common/domain/models/dropdown";

/**
 * GetChecklistMaquinaEquipDropDownUseCase
 */

export class GetChecklistMaquinaEquipDropDownUseCase implements IGetChecklistMaquinaEquipDropDownUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getChecklistMaquinaEquipDropDown(): Promise<DropDown[]> {
    return this.repository.getChecklistMaquinaEquipDropDown();
  }

}
